import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac7952bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "token-mask"
}
const _hoisted_2 = { class: "token-dialog bg-color-black" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "token-title" }, "经营数据大屏 · 访问凭据", -1))
const _hoisted_4 = { class: "token-tabs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "token-tip" }, " 用只读账号（如 dashboard_ro）登录，前端自己调 admin login 换取 accessToken。 勾选「记住凭据」后账号密码只保存在本机浏览器 localStorage，页面刷新/长期展示可自动续期。 ", -1))
const _hoisted_6 = {
  key: 0,
  class: "token-notice"
}
const _hoisted_7 = { class: "token-remember" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "记住凭据（本机 localStorage，用于无人值守自动续期）", -1))
const _hoisted_9 = { class: "token-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "token-tip" }, " 粘贴管理端 Token（登录 admin-api 后拿到的 accessToken）。凭据只保存在本机浏览器 localStorage，不会打进页面产物。 ", -1))
const _hoisted_12 = {
  key: 0,
  class: "token-notice"
}
const _hoisted_13 = { class: "token-actions" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 2,
  class: "token-saved"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("已保存凭据 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("，到期前自动续期")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.authState.promptVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              id: "mode-cred",
              class: _normalizeClass(["token-tab", { active: _ctx.mode === 'cred' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchMode('cred')))
            }, " 账号密码（可自动续期） ", 2),
            _createElementVNode("button", {
              id: "mode-token",
              class: _normalizeClass(["token-tab", { active: _ctx.mode === 'token' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchMode('token')))
            }, " 粘贴 Token ", 2)
          ]),
          (_ctx.mode === 'cred')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                (_ctx.authState.notice)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.authState.notice), 1))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "cred-username",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.username) = $event)),
                  class: "token-input",
                  type: "text",
                  autocomplete: "username",
                  spellcheck: "false",
                  placeholder: "用户名"
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "cred-password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                  class: "token-input mt-10",
                  type: "password",
                  autocomplete: "current-password",
                  spellcheck: "false",
                  placeholder: "密码",
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitCredentials && _ctx.submitCredentials(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.password]
                ]),
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    id: "cred-remember",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.remember) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.remember]
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    id: "cred-submit",
                    class: "token-btn",
                    disabled: !_ctx.username.trim() || !_ctx.password || _ctx.authState.busy,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitCredentials && _ctx.submitCredentials(...args)))
                  }, _toDisplayString(_ctx.authState.busy ? '登录中…' : '登录并进入大屏'), 9, _hoisted_10)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_11,
                (_ctx.authState.notice)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.authState.notice), 1))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "token-input",
                  ref: "inputRef",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.draft) = $event)),
                  class: "token-input",
                  type: "password",
                  autocomplete: "off",
                  spellcheck: "false",
                  placeholder: "粘贴 Token 后回车",
                  onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitToken && _ctx.submitToken(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.draft]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    id: "token-submit",
                    class: "token-btn",
                    disabled: !_ctx.draft.trim(),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitToken && _ctx.submitToken(...args)))
                  }, " 进入大屏 ", 8, _hoisted_14)
                ])
              ], 64)),
          (_ctx.savedUsername)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", null, [
                  _hoisted_16,
                  _createElementVNode("b", null, _toDisplayString(_ctx.savedUsername), 1),
                  _hoisted_17
                ]),
                _createElementVNode("button", {
                  id: "cred-forget",
                  class: "token-link",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.forget && _ctx.forget(...args)))
                }, "清除已保存凭据")
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}